'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Checkbox = require('react-bootstrap/lib/Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Checkbox2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@sketchpixy/rubix/lib/Checkbox.js
 ** module id = ./node_modules/@sketchpixy/rubix/lib/Checkbox.js
 ** module chunks = 0
 **/